// React router that changes between home, workbook and createbonsai
import React, { useEffect } from "react";
// import { bonsai } from "../libs/fakeDesignData";
import { Box, Stack, Typography } from "@mui/material";
import AppBarPlanner from "../../components/AppBar/Planner";
import CreateSite from "../../components/Designer/CreateSite";
import { getLastTimeSeenClient } from "../../libs/toggl/getLastTimeSeenClient";
import { useNavigateToTop } from "../../libs/useNavigateToTop";

function ScreenDesignerCreateSite() {
  const navigate = useNavigateToTop();
  // console.log("rendering");

  return <CreateSite />;
}

export default ScreenDesignerCreateSite;
